export const SAVE = 'save'
export const ACCOUNT_LIST = 'account_list'
export const ACCOUNT_BY_ID = 'account_by_id'
export const SAVE_ACTIVITY = 'save_activity'
export const ACCOUNT_FILTER = 'account_filter'
export const PENDING_ACTIVITY = "pending_activity";
export const EXISTING_SITES = "existing_sites";
export const SITE_VISIT = "site_visit";
export const SITE_VISIT_LIST = "site_visit_list";
export const OPERATION_PROJECT_BY_ID = "operation_project_by_id";
export const VALET_MOM = "valet_mom";
export const VALET_MOM_LIST = "valet_mom_list";
export const VALET_MOM_BY_ID = "valet_mom_by_id";
export const EXTERNAL_MOM_LIST = "external_mom_list";